import React, { useState } from "react";
import { useParams } from "react-router-dom";
import calculatorsData from "./countriesCalculatorData";
import SharedHelmet from "../Helmet";
function CountryCalculators() {
  const { fromParams } = useParams();
  const countryNames = {
    "SA": "السعودية",
    "SY": "سوريا",
    "EG": "مصر",
    "JO": "الأردن",
    "LB": "لبنان",
    "IQ": "العراق",
    "KW": "الكويت",
    "OM": "عمان",
    "QA": "قطر",
    "AE": "الإمارات",
    "BH": "البحرين",
    "MA": "المغرب",
    "TN": "تونس",
    "DZ": "الجزائر",
    "LY": "ليبيا"
  };
  const calculators = calculatorsData[fromParams] || [];
  const [searchTerm, setSearchTerm] = useState("");
  const countryName = countryNames[fromParams] || "الدولة";
  const TITLE = `حاسبات ${countryName}`;
  const DESCRIPTION = `إليك مجموعة من الحاسبات الآلية المخصصة ل ${countryName}، قم باختيار الحاسبة المناسبة لك واحصل على النتائج التي تحتاجها بسهولة وسرعة. سواء كنت طالبًا، موظفًا، أو فردًا عاديًا، ستجد هنا الأدوات التي تساعدك في حساب احتياجاتك اليومية.`;
  const KEYWORDS = `حاسبات، ${countryName}, ${Object.values(countryNames).join("، ")}`;
  const OG_URL = `https://do-calculate.com/calculator/ar/countries/${fromParams}/calculators-list/`;
  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };
  const renderTable = (calculators) => (
    <table >
      <thead>
        <tr>
          <th >اسم الحاسبة</th>
          <th >رابط الحاسبة</th>
        </tr>
      </thead>
      <tbody>
        {calculators
          .filter((calculator) => calculator.name.includes(searchTerm))
          .map((calculator) => (
            <tr key={calculator.name}>
              <td>{calculator.name}</td>
              <td>
                <a href={calculator.url}>انتقل إلى {calculator.name}</a>
              </td>
            </tr>
          ))}
      </tbody>
    </table>
  );
  return (
    <div>
      <div className="container rtl-container">
        <SharedHelmet
          TITLE={TITLE}
          DESCRIPTION={DESCRIPTION}
          KEYWORDS={KEYWORDS}
          OG_URL={OG_URL}
        />
        <div>
          <h1 style={{ fontSize: "26px" }}>{TITLE}</h1>
          <hr />
          <div className="alert alert-secondary" role="alert">
            <p>{DESCRIPTION}</p>
          </div>
        </div>
        <hr />
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            paddingBottom: "15px",
          }}
        >
          <h2 style={{ margin: 0 }}>حاسبات {fromParams}</h2>
          <input
            type="text"
            placeholder="ابحث عن حاسبة..."
            value={searchTerm}
            onChange={handleSearchChange}
            style={{
              padding: "10px",
              borderRadius: "5px",
              border: "1px solid #ccc",
              width: "200px",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            }}
          />
        </div>
        {renderTable(calculators)}
        <br />
      </div>
    </div>
  );
}
export default CountryCalculators;
